<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { ConclusionMessage } from '@/store/consultation.interface';
import { getLabel, getTranslation } from '@/utils/data-display-utils';
import { paths } from '@/utils/paths';

import BaseButton from './base/BaseButton.vue';
import { Locales } from '@/store/language.interface';

// CONST
const router = useRouter();

// PROPS
const props = defineProps<{
  conclusionMessage: ConclusionMessage;
  consultationHasProject: boolean;
  projectSlug?: string;
  languageEnabled?: Locales[];
}>();

// COMPUTED
const setButtonText = computed(() => {
  return props.consultationHasProject
    ? getLabel('consultation.conclusion-message.return-to-project', props.languageEnabled)
    : getLabel('consultation.conclusion-message.return-to-home', props.languageEnabled);
});

// FUNCTIONS
function returnTo() {
  if (props.consultationHasProject && props.projectSlug) {
    router.push({
      name: 'project',
      params: { slug: props.projectSlug },
    });
  } else {
    router.push(paths.root);
  }
}
</script>
<template>
  <div class="conclusion-message">
    <div class="conclusion-message__content">
      <h3>{{ getTranslation(props.conclusionMessage, 'content', props.languageEnabled) }}</h3>
    </div>
    <BaseButton :text="setButtonText" color="primary" @click="returnTo" />
  </div>
</template>
<style lang="scss">
.conclusion-message {
  height: 100%;
  align-self: start;
  display: flex;
  flex-direction: column;
  background-color: $color-neutral-white;
  border-radius: $space-sm;
  padding: $space-lg;
  margin: $space-md 10% $space-md 10%;
  gap: $space-md;

  &__content {
    color: $color-primary-darken;
  }
}
</style>
